import styles from './ProductsGrid.scss';

import cx from 'classnames';
import React from 'react';

import { Product } from 'src/api/contentful/contentTypes.cloverdotcom';
import { Entries } from 'src/api/contentful/utilTypes';
import { componentKey } from 'src/utils/EntryUtil';

import { ProductCard } from '../ProductCard/ProductCard';

export interface IProductsGrid extends React.AllHTMLAttributes<HTMLUListElement> {
  entries?: Entries<Product>;
  active?: boolean;
  mobile?: boolean;
  tablet?: boolean;
}

export const ProductsGrid: React.FC<IProductsGrid> = ({
  active, mobile, tablet, entries = [], className, ...props
}) => {
  const length = entries.length;

  if (length < 1) return null;

  const isEven = length % 2 === 0;

  const isDesktop = !tablet && !mobile;

  return (
    <ul
      className={cx(className, styles.productsGrid, {
        [styles.productsGridTwoCol]: length <= 3,
      })}
      {...props}
    >
      {entries.map((entry, index) => {
        const isLast = index === length - 1;

        const large = (
          // mobile or tablet, one and only
          ((mobile || tablet) && length === 1) ||

          // mobile, more than 2, last and odd
          (mobile && length > 2 && isLast && !isEven) ||

          // tablet, more than 2 last and odd
          (tablet && length > 2 && isLast && !isEven) ||

          // tablet, exactly 4, 2nd or 4th
          (tablet && length === 4 && (index === 1 || index === 3)) ||

          // desktop, more than 4, last and odd
          (isDesktop && length > 4 && isLast && !isEven)
        );

        return (
          <ProductCard
            large={large}
            className={cx(styles.item, {
              [styles.itemLarge]: large,
            })}
            key={componentKey(entry, index)}
            entry={entry}
            active={active}
          />
        );
      })}
    </ul>
  );
};
